import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/users/financial/new',
  title: 'Cadastrar Financeiro',
  endpoint: '/app/person',
}
